import BpkText, {
  TEXT_STYLES,
} from '@skyscanner-internal/backpack-web/bpk-component-text';

import { logWarnWrapper } from '../../../../services/logWrapper';
import { COMPONENT_CAPYBARA_RECOMMENDATIONS } from '../../helpers/constants/analyticsConstants';
import { useTranslation } from '../../helpers/hooks/useTranslation';

import ProductLink from './ProductLink';

import type { HotelInfo } from './types';

type HotelSectionProps = {
  hotel: HotelInfo;
  onLinkClick?: () => void;
};

const HotelSection = ({ hotel, onLinkClick }: HotelSectionProps) => {
  const translate = useTranslation();

  return (
    <div className="recommendation-card__product">
      <span className="recommendation-card__product-label">
        <BpkText textStyle={TEXT_STYLES.footnote}>
          {translate('ktxt_combo_rec_your_stay')}
        </BpkText>
      </span>
      <div className="recommendation-card__hotel">
        <img
          className="recommendation-card__hotel-image"
          src={hotel.imageUrl}
          alt={hotel.name}
          onError={() =>
            logWarnWrapper({
              message: 'Hotel image unavailable',
              component: COMPONENT_CAPYBARA_RECOMMENDATIONS,
              onClickUrl: hotel.onClickUrl || '',
              imageUrl: hotel.imageUrl,
              hotelName: hotel.name,
            })
          }
        />
        <div className="recommendation-card__hotel-info">
          <BpkText
            textStyle={TEXT_STYLES.label2}
            tagName="span"
            className="recommendation-card__hotel-name"
            title={hotel.name}
          >
            {hotel.name}
          </BpkText>
          <span className="recommendation-card__hotel-detail">
            <BpkText textStyle={TEXT_STYLES.caption}>
              {hotel.distanceLabel}
            </BpkText>
          </span>
          {hotel.rating && (
            <span
              className="recommendation-card__hotel-detail"
              aria-label={translate('ktxt_combo_rec_star_rating', {
                score: hotel.rating,
              })}
            >
              <BpkText textStyle={TEXT_STYLES.caption} aria-hidden="true">
                {translate.tWithElements('ktxt_combo_rec_star_rating', {
                  score: (
                    <strong className="recommendation-card__hotel-rating-score">
                      {hotel.rating}
                    </strong>
                  ),
                })}
              </BpkText>
            </span>
          )}
        </div>
      </div>
      <ProductLink
        label={translate('ktxt_combo_rec_hotel_from_price', {
          price: hotel.priceFormatted,
        })}
        href={hotel.onClickUrl}
        onClick={onLinkClick}
      />
    </div>
  );
};

export default HotelSection;
